export default __webpack_public_path__ + "static/media/bluepipes-2017.03f58141.png";